import type React from "react"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog"
import { ScrollArea } from "@/components/ui/scroll-area"

interface PrivacyPolicyPopupProps {
  isOpen: boolean
  onClose: () => void
}

const PrivacyPolicyPopup: React.FC<PrivacyPolicyPopupProps> = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Privacy Policy</DialogTitle>
          <DialogDescription>Last updated: February 2025</DialogDescription>
        </DialogHeader>
        <ScrollArea className="mt-4 max-h-[60vh] pr-4">
          <div className="space-y-4 text-sm">
            <p>
              At Coverage Maps, we take your privacy seriously. This Privacy Policy explains how we collect, use, and
              protect your personal information.
            </p>

            <h3 className="font-semibold text-base">Information We Collect</h3>
            <ul className="list-disc pl-5 space-y-2">
              <li>Usage data related to your interaction with our mapping tools</li>
              <li>Territory and region data that you input into our system</li>
              <li>Basic contact information if you reach out to us</li>
              <li>Technical information necessary for improving our service</li>
            </ul>

            <h3 className="font-semibold text-base">How We Use Your Information</h3>
            <ul className="list-disc pl-5 space-y-2">
              <li>To provide and improve our territory mapping services</li>
              <li>To respond to your inquiries and support requests</li>
              <li>To maintain and enhance the security of our platform</li>
              <li>To analyze usage patterns and optimize user experience</li>
            </ul>

            <h3 className="font-semibold text-base">Data Security</h3>
            <p>
              We implement industry-standard security measures to protect your data. Your territory information is
              encrypted and stored securely.
            </p>

            <h3 className="font-semibold text-base">Contact Us</h3>
            <p>
              If you have any questions about our privacy practices, please contact us at{" "}
              <a href="mailto:contact@coverage-maps.com" className="text-blue-600 hover:underline">
                contact@coverage-maps.com
              </a>
              .
            </p>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}

export default PrivacyPolicyPopup
